import { SectionRow, ShowSection, ShowPageLayout } from 'framework/ui/layout';
import AccountingCycleHeader from '../shared/AccountingCycleHeader';
import AccountingCycleBreadcrumbsItem from './AccountingCycleBreadcrumbsItem';
import CloseAccountingCycleButton from '../shared/button/CloseAccountingCycleButton';
import { DateField, EnumField, FullDateField, TextField, useFieldHelper } from 'framework/ui/field';
import {
  ACCOUNTING_CYCLE_EVENTS,
  ACCOUNTING_CYCLE_EVENTS_OPTIONS,
  ACCOUNTING_CYCLE_OPTIONS,
  ACCOUNTING_CYCLE_STATUS,
  AccountingCycleEventType,
  AccountingCycleType,
} from '../useAccountingCycle';
import { ControlledList as List, DataGridLayout } from 'framework/list';
import AccountingCycleActionButton from 'domain/finance/costAccounting/accountingCycle/shared/button/AccountingCycleActionButton';
import { Box } from '@mui/material';
import PerformSandboxDistributionButton from 'domain/finance/payroll/payrollDistribution/shared/button/PerformSandboxDistributionButton';
import { EmployeeLinkFieldWithNameLoading } from 'domain/shared/employee';
import MigrateExpenseAccrualsButton from 'domain/finance/expenses/shared/button/MigrateExpenseAccrualsButton';

const ViewAccountingCycleContent = () => {
  const { getValue: getEvents } = useFieldHelper<AccountingCycleEventType[]>({ source: 'events' });
  const { getValue: getId } = useFieldHelper<string>({ source: 'id' });
  const events = getEvents();
  const id = getId();
  const listData = {
    totalPages: 1,
    totalElements: Object.values(ACCOUNTING_CYCLE_EVENTS).length,
    items: Object.values(ACCOUNTING_CYCLE_EVENTS).map(event => {
      const eventData = events?.find((item: AccountingCycleEventType) => item?.eventType === event);
      return {
        id: event,
        eventType: ACCOUNTING_CYCLE_EVENTS_OPTIONS[event],
        triggeredBy: eventData?.triggeredBy || null,
        createdAt: eventData?.createdAt || null,
        event,
      };
    }),
  };

  return (
    <ShowPageLayout
      entityHeader={<AccountingCycleHeader />}
      breadcrumbs={<AccountingCycleBreadcrumbsItem />}
      headerButtons={[
        <CloseAccountingCycleButton />,
        <PerformSandboxDistributionButton />,
        <MigrateExpenseAccrualsButton />,
      ]}
    >
      <ShowSection title="Main information">
        <SectionRow>
          <TextField source="id" label="Cycle" />
          <EnumField source="status" label="Status" options={ACCOUNTING_CYCLE_OPTIONS} />
        </SectionRow>

        <List data={listData}>
          <Box
            sx={{
              '* .list-general .list-btn-container .MuiButtonBase-root': { width: 'auto' },
              '* .list-general .list-btn-container': { textAlign: 'left' },
            }}
          >
            <DataGridLayout
              showPagination={false}
              showTotal={false}
              buttons={[<AccountingCycleActionButton id={id} />]}
            >
              <TextField label="Event type" source="eventType" width="25%" />
              <EmployeeLinkFieldWithNameLoading label="Triggered by" source="triggeredBy" width="25%" />
              <FullDateField label="Completed at" source="createdAt" width="25%" />
            </DataGridLayout>
          </Box>
        </List>

        <SectionRow>
          <EmployeeLinkFieldWithNameLoading
            isVisible={(data: AccountingCycleType) => data?.status === ACCOUNTING_CYCLE_STATUS.CLOSE}
            label="Closed by"
            source="closedBy"
          />
          <DateField
            isVisible={(data: AccountingCycleType) => data?.status === ACCOUNTING_CYCLE_STATUS.CLOSE}
            source="closedAt"
            label="Closed at"
          />
        </SectionRow>
      </ShowSection>
    </ShowPageLayout>
  );
};

export default ViewAccountingCycleContent;
